export const STATE_NAME = 'experiments';

export enum ActionTypes {
  SET_VARIANTS = 'EXPERIMENTS/SET_VARIANTS',
  PLAY_EXPERIMENT = 'EXPERIMENTS/PLAY_EXPERIMENT',
}
